export const euEmailAdsOwsOptionsFeatureType = 42;
export default euEmailAdsOwsOptionsFeatureType;
